import { tokenStore } from '../token-store';
import { createApiClient } from './client';

export { ApiError } from './client';

type UnauthorizedListener = () => void;
const listeners = new Set<UnauthorizedListener>();

/** Lets the session layer react when the server rejects the stored token. */
export function onUnauthorized(listener: UnauthorizedListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const BASE_URL = import.meta.env.VITE_API_URL || '/api/v1';

/** An address under the API, for things the browser loads itself, such as images. */
export function apiUrl(path: string): string {
  return `${BASE_URL.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

export const api = createApiClient({
  baseUrl: BASE_URL,
  getToken: tokenStore.get,
  onUnauthorized: () => listeners.forEach((listener) => listener()),
});
